import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
import {
  ORDER_UPDATE_LOADING,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_ERROR,
  ORDER_UPDATE_CANCEL,
  ORDER_UPDATE_START,
  RESIN_ORDER_UPDATE_LOADING,
  RESIN_ORDER_UPDATE_SUCCESS,
  RESIN_ORDER_UPDATE_ERROR,
  RESIN_ORDER_UPDATE_START,
  RESIN_ORDER_UPDATE_CANCEL,
} from '@src/app/accounts/orders';

export type State = {
  readonly loading: boolean;
  orders: Array<any> | null;
  orderUpdateResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case ORDER_UPDATE_SUCCESS:
      case ORDER_UPDATE_ERROR:
      case ORDER_UPDATE_CANCEL:
      case RESIN_ORDER_UPDATE_SUCCESS:
      case RESIN_ORDER_UPDATE_ERROR:
      case RESIN_ORDER_UPDATE_CANCEL:
        return false;
      case ORDER_UPDATE_LOADING:
      case RESIN_ORDER_UPDATE_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  orders: (state = null, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return action.payload.orders;
      default:
        return state;
    }
  },
  orderUpdateResult: (state = null, action) => {
    switch (action.type) {
      case ORDER_UPDATE_SUCCESS:
      case ORDER_UPDATE_ERROR:
      case RESIN_ORDER_UPDATE_SUCCESS:
      case RESIN_ORDER_UPDATE_ERROR:
        return action.payload;
      case ORDER_UPDATE_CANCEL:
      case ORDER_UPDATE_START:
      case RESIN_ORDER_UPDATE_CANCEL:
      case RESIN_ORDER_UPDATE_START:
        return null;
      default:
          return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/orders/reducer.ts